// Imports
import { Component, ViewChild } from '@angular/core';
import { HttpService } from '../shared/services/http.service';
import { DialogComponent } from '../dialog/dialog.component';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { TranslationMessagePage } from './translation-messages/translation-messages-page'
import { TranslationMessagesResultService } from './translation-messages/translationResultService'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SessionHandler } from '../shared/services/session-handler.service';
import { APPCONFIG } from '../config';

// Component Decorator
@Component({
  template: require('./translation-messages.component.html'),
  styles: [ require('../../app/newCommon.scss')],
  providers: [TranslationMessagesResultService]
})

// Component Class
export class TranslationMessagesComponent {
    @ViewChild(DatatableComponent) table: DatatableComponent;
    page = new TranslationMessagePage();
    LanguageData:any;
    tableRows: any = [];
    filters: any = {};
    selected = [];
    selectedStatusId: string = '';
    selectedCount: any;
    language2: any = [];
    searchText: any;
    ProfileForm: FormGroup;
    userDetails:any;
    responseLanguageId:any;
    profileData: any;
    isSystemAdmin: boolean = false;
    isApplicationManager: boolean = false;
    isBUManager: boolean = false;
    isRegionalAdmin: boolean = false;
    isServiceOwner: boolean = false;
    isTradePartner: boolean = false;
    isSubUser: boolean = false;
    
    constructor(public httpService: HttpService, private formBuilder: FormBuilder, public sessionHandler: SessionHandler,
         private serverResultsService: TranslationMessagesResultService,){

            APPCONFIG.navCollapsed = true;
        this.userDetails = JSON.parse(this.sessionHandler.getItem('loginData'));
        if (this.userDetails && Object.keys(this.userDetails).length > 0 && this.userDetails.roleCode && this.userDetails.roleCode.length > 0) {
            if (this.userDetails.roleCode.includes(APPCONFIG.systemAdmin)) {
                this.isSystemAdmin = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.applicationManager)) {
                this.isApplicationManager = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.BUManager)) {
                this.isBUManager = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.regionalAdmin)) {
                this.isRegionalAdmin = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.serviceOwner)) {
                this.isServiceOwner = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.tradePartner)) {
                this.isTradePartner = true;
            }
            if (this.userDetails.roleCode.includes(APPCONFIG.subuser)) {
                this.isSubUser = true;
            }
        } else {
            this.httpService.noUserError();
        }
        this.getlanguages();
        this.page.pageNumber = 0;
        this.page.size = 20;
        this.filters['offSet'] = this.page.pageNumber * this.page.size;
        this.filters['limit'] = this.page.size;
        if (this.isSystemAdmin) {
            this.profileData = this.userDetails;
        if(this.profileData.languageId){
            this.setLanguage(this.profileData.languageId);
        }
    }
        
    }
    public setLanguage(languageId){
        this.responseLanguageId = languageId;
        this.buildForm();
        this.getTranslationData(this.filters);

    }
    buildForm() {
        this.ProfileForm = this.formBuilder.group({
            languageId: this.formBuilder.control(this.responseLanguageId, [Validators.required])
        });}
    public search() {
        this.selected = [];
        this.filters['offSet'] = 0;
        this.getTranslationData(this.filters);
    }
    resetDateFlag: boolean;
    public resetSearch() {
        this.searchText = "";
        this.resetDateFlag = true;
        if(this.profileData.languageId){
            this.setLanguage(this.profileData.languageId);
        }
        this.search();
    }
    updateBtn(rowdata, editedText){
        console.log(rowdata);
        console.log(editedText);
        let data = {};
        data['id'] = rowdata['id'];
        data['text'] = editedText;
        this.httpService.postRequest(data,'superUserOperationsApi/v1/multilingualText').subscribe(
            res => {
                console.log(res);
                this.getTranslationData(this.filters);
            },
            err => { this.httpService.onEnd(); }
        );

        
    }
    public getlanguages(){
        this.httpService.getRequest('lookupDataOperationsApi/v1/language').subscribe(
            res => { this.savelanguageResponse(res); },
            err => { this.httpService.onEnd(); }
        );
    }

    //Save languages Response
    public savelanguageResponse(res) {
        
        if(res && res.items){
            this.LanguageData = res.items;
        }
        this.httpService.onEnd();
    }
    langId;
    onLanguageChange(languageId){
        console.log(languageId);
        this.responseLanguageId = languageId;
       
        this.getTranslationData(this.filters);
    }
    
    getTranslationData(filter){
        if(this.searchText == undefined){
            this.searchText = "";
        }
        this.httpService.getRequest("superUserOperationsApi/v1/multilingualText/list/"+this.responseLanguageId+"?limit=" + filter.limit + "&offset=" + filter.offSet+"&search="+this.searchText ).subscribe(
            res => {
                console.log(res);
                
                this.saveTranslationList(res, filter);

            },
            err => {
                this.httpService.onEnd();
            });
    }
    public saveTranslationList = function (res, filter) {
        if (res.errorStatus == 'Fail') {
            this.httpService.onEnd();
            this.dialogRef = this.dialog.open(DialogComponent);
            this.dialogRef.componentInstance.msg = 'data_pull_fail';
        } else {
            if (res && Object.keys(res).length > 0) {
                this.translationData = res;
                this.rows = [];
                this.rows['offset'] = res.offset;
                this.count = res.count;
                this.totalCount = res.totalCount;

                if (this.translationData.list) {
                    let totalCount = 0;
                    if (parseInt(res.offset) == 0) {
                        localStorage.setItem('totalCount', res.totalCount);
                        totalCount = parseInt(res.totalCount);
                    } else {
                        totalCount = parseInt(localStorage.getItem('totalCount'));
                    }

                    this.rows['totalCount'] = totalCount;
                    for (let data in this.translationData.list) {
                        
                        this.rows[data] = {};
                        this.rows[data]['id'] = this.translationData.list[data]['id'];
                        this.rows[data]['key'] = this.translationData.list[data]['key'];
                        this.rows[data]['english'] = this.translationData.list[data]['englishText'];
                        this.rows[data]['selectLanguage'] = this.translationData.list[data]['text'];
                        this.rows[data]['actionFlag'] = true;
                        this.language2[data] = this.translationData.list[data]['text'];
                        
                    }
                    this.showTable = true;
                    this.temp = this.rows;
                } else {
                    this.showTable = false;
                }
                let finalRows = [];
                for (let f in this.rows) {
                    if (f != 'offset' && f != 'totalCount' && this.rows[f]) {
                        finalRows.push(this.rows[f]);
                    }
                    if (f == 'offset') {
                        finalRows['offset'] = this.rows['offset'];
                    }
                    if (f == 'totalCount') {
                        finalRows['totalCount'] = this.rows['totalCount'];
                    }
                }
                this.rows = finalRows;
                this.setPage({ offset: this.rows['offset'] / this.page.size }, finalRows, filter);
                this.httpService.onEnd();
            }
        }
    }
    public setPage(pageInfo, rows, filter) {
        this.page.pageNumber = pageInfo.offset;
        if (rows.length != 0) {
            this.serverResultsService.getResults(this.page, rows).subscribe(pageData => {
                this.page = pageData.page;
                this.tableRows = pageData.data;
                if (!filter) {
                    if (Object.keys(this.tableRows).length == 0 || !this.tableRows[0]['status']) {
                        this.filters['offSet'] = this.page.pageNumber * this.page.size;
                        this.getTranslationData(this.filters);
                    }
                }
            });
        } else {
            this.tableRows = [];
            this.page.totalElements = rows.length;
        }
    }
    onSelect({ selected }) {
        this.selected.splice(0, this.selected.length);
        this.selected.push(...selected);
        this.selectedCount = this.selected.length;
    }

} 


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/translation-messages/translation-messages.component.ts